import { PriceListSchoolApiDto } from '@lx/shared/api/models';

export const CompanyEnum = PriceListSchoolApiDto.CompanyEnum;
export type CompanyEnum = PriceListSchoolApiDto.CompanyEnum;
export type Company = PriceListSchoolApiDto.CompanyEnum;
